<template>
  <q-dialog v-model="isOpen" persistent>
    <q-card style="min-width: 400px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">
          <q-icon name="schedule" class="q-mr-sm" />
          Agendar Pergunta
        </div>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>

      <q-card-section>
        <div class="q-mb-md">
          <label class="text-subtitle2 text-weight-medium">Pergunta:</label>
          <q-input
            v-model="perguntaLocal"
            outlined
            readonly
            bg-color="grey-1"
            class="q-mt-xs"
            type="textarea"
            rows="3"
          />
        </div>

        <div class="q-mb-md">
          <label class="text-subtitle2 text-weight-medium">Ambiente:</label>
          <q-input
            v-model="dadosAgendamento.ambiente"
            outlined
            readonly
            bg-color="grey-1"
            class="q-mt-xs"
          />
        </div>

        <div class="q-mb-md">
          <label class="text-subtitle2 text-weight-medium">Nome:</label>
          <q-input
            v-model="dadosAgendamento.nome"
            outlined
            readonly
            bg-color="grey-1"
            class="q-mt-xs"
          />
        </div>

        <div class="q-mb-md">
          <label class="text-subtitle2 text-weight-medium">E-mail:</label>
          <q-input
            v-model="dadosAgendamento.email"
            outlined
            readonly
            bg-color="grey-1"
            class="q-mt-xs"
            type="email"
          />
        </div>

        <div class="q-mb-md">
          <label class="text-subtitle2 text-weight-medium">Telefone:</label>
          <q-input
            v-model="dadosAgendamento.telefone"
            outlined
            placeholder="(11) 98888-8888"
            class="q-mt-xs"
            mask="(##) #####-####"
            :rules="[validarTelefone]"
          />
        </div>

        <div class="q-mb-md">
          <label class="text-subtitle2 text-weight-medium"
            >Horário de Disparo:</label
          >
          <q-input
            model-value="Entre 04:00 e 06:00am diariamente"
            outlined
            readonly
            bg-color="grey-1"
            class="q-mt-xs"
          />
          <div class="text-caption text-grey-6 q-mt-xs">
            * No momento não é possiível alterar esse agendamento.
          </div>
        </div>

        <!-- Indicador de agendamentos existentes -->
        <div class="q-mb-md">
          <div v-if="carregandoAgendamentos" class="text-center q-pa-sm">
            <q-spinner size="20px" color="primary" />
            <div class="text-caption q-mt-xs">Verificando agendamentos...</div>
          </div>

          <div
            v-else
            class="q-pa-sm rounded-borders"
            :class="{
              'bg-green-1 text-green-8': agendamentosExistentes < 2,
              'bg-orange-1 text-orange-8': agendamentosExistentes >= 2,
            }"
          >
            <div class="row items-center">
              <q-icon
                :name="agendamentosExistentes >= 2 ? 'warning' : 'check_circle'"
                class="q-mr-sm"
              />
              <div class="text-body2">
                <strong
                  >{{ agendamentosExistentes }}/2 agendamentos
                  utilizados</strong
                >
              </div>
            </div>
            <div
              v-if="agendamentosExistentes >= 2"
              class="text-caption q-mt-xs"
            >
              Você atingiu o limite máximo. Exclua um agendamento para criar
              outro.
            </div>
            <div v-else class="text-caption q-mt-xs">
              Você pode criar mais
              {{ 2 - agendamentosExistentes }} agendamento(s).
            </div>
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-pa-md">
        <q-btn flat label="Cancelar" v-close-popup />
        <q-btn
          color="primary"
          label="Agendar"
          @click="agendarPergunta"
          :loading="enviando"
          :disable="!formularioValido"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, computed, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import axios from "axios";

export default {
  name: "AgendamentoModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    pergunta: {
      type: String,
      default: "",
    },
    cliente: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue", "agendado"],
  setup(props, { emit }) {
    const $q = useQuasar();
    const store = useStore();
    const enviando = ref(false);
    const carregandoAgendamentos = ref(false);
    const agendamentosExistentes = ref(0);
    const perguntaLocal = ref("");

    const dadosAgendamento = ref({
      ambiente: "",
      nome: "",
      email: "",
      telefone: "",
    });

    const isOpen = computed({
      get: () => props.modelValue,
      set: (val) => emit("update:modelValue", val),
    });

    const formularioValido = computed(() => {
      return (
        dadosAgendamento.value.telefone &&
        dadosAgendamento.value.telefone.trim() !== ""
      );
    });

    // Preencher dados automaticamente quando o modal abre
    watch(
      () => props.modelValue,
      async (novoValor) => {
        if (novoValor) {
          perguntaLocal.value = props.pergunta;

          // Preencher com dados do usuário logado
          const usuarioLogado = store.state.autenticacao.usuarioLogado;
          const cliente = store.state.autenticacao.cliente[0];

          dadosAgendamento.value.ambiente = cliente || "";
          dadosAgendamento.value.nome = usuarioLogado.nome || "";
          dadosAgendamento.value.email = usuarioLogado.email || "";

          // Carregar telefone salvo anteriormente
          const telefoneKey = `telefone_agendamento_${usuarioLogado.email}`;
          const telefoneSalvo = localStorage.getItem(telefoneKey);
          if (telefoneSalvo) {
            dadosAgendamento.value.telefone = telefoneSalvo;
          } else {
            dadosAgendamento.value.telefone = "";
          }

          // Carregar número de agendamentos existentes
          carregandoAgendamentos.value = true;
          agendamentosExistentes.value = await verificarLimiteAgendamentos();
          carregandoAgendamentos.value = false;
        }
      }
    );

    // Função para validar telefone
    const validarTelefone = (val) => {
      if (!val) return "Telefone é obrigatório";

      // Remove caracteres não numéricos
      const apenasNumeros = val.replace(/\D/g, "");

      // Verifica se tem exatamente 11 dígitos (DDD + número)
      if (apenasNumeros.length !== 11) {
        return "Telefone deve ter 11 dígitos (DDD + número)";
      }

      // Verifica se o DDD é válido (11-99)
      const ddd = parseInt(apenasNumeros.substring(0, 2));
      if (ddd < 11 || ddd > 99) {
        return "DDD inválido";
      }

      return true;
    };

    // Função para formatar telefone para envio (55 + DDD + número)
    const formatarTelefoneParaEnvio = (telefone) => {
      const apenasNumeros = telefone.replace(/\D/g, "");
      return `55${apenasNumeros}`;
    };

    // Função para verificar número de agendamentos existentes
    const verificarLimiteAgendamentos = async () => {
      try {
        const usuarioLogado = store.state.autenticacao.usuarioLogado;
        const cliente = store.state.autenticacao.cliente[0];

        const response = await axios.get(
          "https://n8n.devops.multpex.com.br/webhook/89242345-d4e6-4be5-96ae-bdea27a28e51",
          {
            params: {
              ambiente: cliente,
              email: usuarioLogado.email,
            },
          }
        );

        const agendamentosExistentes = response.data || [];
        return agendamentosExistentes.length;
      } catch (error) {
        console.error("Erro ao verificar agendamentos existentes:", error);
        // Em caso de erro, permite continuar (fallback)
        return 0;
      }
    };

    const agendarPergunta = async () => {
      if (!formularioValido.value) {
        $q.notify({
          type: "negative",
          message: "Por favor, preencha o telefone",
        });
        return;
      }

      // Verificar limite de agendamentos
      const numeroAgendamentos = await verificarLimiteAgendamentos();

      if (numeroAgendamentos >= 2) {
        $q.notify({
          type: "negative",
          message: "Limite de agendamentos atingido",
          caption:
            "Você pode ter no máximo 2 agendamentos ativos. Exclua um agendamento existente para criar um novo.",
        });
        return;
      }

      enviando.value = true;

      try {
        const payload = {
          ambiente: dadosAgendamento.value.ambiente,
          nome: dadosAgendamento.value.nome,
          email: dadosAgendamento.value.email,
          telefone: formatarTelefoneParaEnvio(dadosAgendamento.value.telefone),
          pergunta: perguntaLocal.value,
          tipoAgendamento: "diario",
          horario: "04:00-06:00",
          criadoEm: new Date().toISOString(),
        };

        const response = await axios.post(
          "https://n8n.devops.multpex.com.br/webhook/e45d28d0-6811-4943-abd9-c1f53681dc55",
          payload
        );

        $q.notify({
          type: "positive",
          message: "Pergunta agendada com sucesso!",
          caption: "Você receberá a resposta diariamente entre 04:00 e 06:00",
        });

        // Disparar processamento imediato da pergunta usando o ID retornado
        try {
          console.log("Resposta do agendamento:", response.data);

          let documentId = null;

          // Tentar diferentes estruturas de resposta
          if (Array.isArray(response.data) && response.data.length > 0) {
            documentId = response.data[0]._id || response.data[0].id;
          } else if (response.data && (response.data._id || response.data.id)) {
            documentId = response.data._id || response.data.id;
          }

          console.log("ID extraído:", documentId);

          if (documentId) {
            await axios.post(
              "https://n8n.devops.multpex.com.br/webhook/2f8422a2-3ad0-4d1d-b861-73507c90f0ad",
              {
                id: documentId,
              }
            );

            $q.notify({
              type: "info",
              message: "Processamento iniciado!",
              caption: "A pergunta foi enviada para processamento imediato",
            });
          } else {
            console.warn(
              "ID do documento não encontrado na resposta do agendamento",
              response.data
            );
          }
        } catch (disparoError) {
          console.warn(
            "Erro ao disparar processamento imediato:",
            disparoError
          );
          // Não interrompe o fluxo se o disparo falhar
        }

        // Salvar telefone no localStorage para próximos agendamentos
        const usuarioLogado = store.state.autenticacao.usuarioLogado;
        const telefoneKey = `telefone_agendamento_${usuarioLogado.email}`;
        localStorage.setItem(telefoneKey, dadosAgendamento.value.telefone);

        emit("agendado", payload);
        isOpen.value = false;
      } catch (error) {
        console.error("Erro ao agendar pergunta:", error);
        $q.notify({
          type: "negative",
          message: "Erro ao agendar pergunta",
          caption: "Tente novamente em alguns instantes",
        });
      } finally {
        enviando.value = false;
      }
    };

    return {
      isOpen,
      perguntaLocal,
      dadosAgendamento,
      formularioValido,
      enviando,
      carregandoAgendamentos,
      agendamentosExistentes,
      agendarPergunta,
      validarTelefone,
    };
  },
};
</script>

<style scoped>
.q-card {
  border-radius: 12px;
}

.q-input {
  border-radius: 8px;
}

label {
  color: #333;
}
</style>
